export const CALLABLE_FUNCTIONS = {
  getPortalLink: "getPortalLink" as const,
  inviteUser: "inviteUser" as const,
  disableUser: "disableUser" as const,
  enableUser: "enableUser" as const,
  deleteUser: "deleteUser" as const,
  registerWithEmailAndPassword: "registerWithEmailAndPassword" as const
};
